import { render } from "./PhysiciansLastNameFilter.vue?vue&type=template&id=adbe0786"
import script from "./PhysiciansLastNameFilter.vue?vue&type=script&lang=js"
export * from "./PhysiciansLastNameFilter.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__